export default "__VITE_ASSET__Bhj088ry__"